export default __webpack_public_path__ + "static/media/ADMIN.01a25e22.jpg";